module.exports = __webpack_public_path__ + "static/verimatrix-4db9227c16357bc4ab07d1f5c2dcbcca.png";